class CustomScroller extends HTMLElement {
	constructor() {
		super();
		this.isScrollable = this.scrollWidth > this.offsetWidth;
		this.wrapper = this.closest('[data-custom-scroller-parent]');
		this.scrollIcon = this.wrapper.querySelector('[data-custom-scroller-icon]');
		this.isTouchscreen = window.matchMedia('(pointer: coarse)').matches;

		this.clickToScroll = this.clickToScroll.bind(this);

		this.currentScrollPosition = this.scrollLeft;

		this.isDown = false;
	}

	connectedCallback() {
		if (this.isScrollable) {
			this.scrollIcon.setAttribute('visible', '');
		}
		this.addEventListener('scroll', this.checkEndOfScroll);
		if (this.isTouchscreen) return;

		this.dragToScroll();

		document.addEventListener('swup:contentReplaced', () => {
			this.dragToScroll();
			this.clickToScroll();
		});

		this.scrollIcon.addEventListener('click', this.clickToScroll);

		let scrollInterval;

		const startContinuousScroll = () => {
			scrollInterval = setInterval(() => {
				this.clickToScroll();
			}, 100);
		};

		const stopContinuousScroll = () => {
			clearInterval(scrollInterval);
		};

		this.scrollIcon.addEventListener('mousedown', () => {
			startContinuousScroll();

			document.addEventListener('mouseup', stopContinuousScroll, {
				once: true,
			});
		});
	}

	checkEndOfScroll() {
		const isAtEnd =
			Math.ceil(this.scrollLeft) + this.clientWidth >= this.scrollWidth;

		if (isAtEnd) {
			this.scrollIcon.removeAttribute('visible', '');
		} else {
			this.scrollIcon.setAttribute('visible', '');
		}
	}

	dragToScroll() {
		let startX;
		let scrollLeft;

		this.addEventListener('mousedown', (e) => {
			this.isDown = true;
			this.classList.add('active');
			startX = e.pageX;
			scrollLeft = this.scrollLeft;
		});

		document.addEventListener('mouseup', () => {
			if (!this.isDown) return;

			this.isDown = false;
			this.classList.remove('active');
			this.currentScrollPosition = this.scrollLeft;
		});

		this.addEventListener('mousemove', (e) => {
			if (!this.isDown) return;
			e.preventDefault();
			this.scrollLeft = scrollLeft - (e.pageX - startX);
		});
	}

	clickToScroll() {
		const scrollableAmount = this.scrollWidth - this.offsetWidth;
		let amountToScrollBy = 50;

		const remainingScrollableAmount =
			scrollableAmount - this.currentScrollPosition;

		if (remainingScrollableAmount <= amountToScrollBy) {
			amountToScrollBy = remainingScrollableAmount;
		}

		if (remainingScrollableAmount <= 0) {
			return;
		}

		const startScrollPosition = this.currentScrollPosition;
		const duration = 100;
		const startTime = performance.now();

		const animateScroll = (currentTime) => {
			const elapsedTime = currentTime - startTime;
			const progress = Math.min(elapsedTime / duration, 1);

			this.currentScrollPosition =
				startScrollPosition + amountToScrollBy * progress;
			this.scrollLeft = this.currentScrollPosition;

			if (progress < 1) {
				window.requestAnimationFrame(animateScroll);
			}
		};

		window.requestAnimationFrame(animateScroll);
	}
}

if (!customElements.get('custom-scroller')) {
	customElements.define('custom-scroller', CustomScroller, { extends: 'nav' });
}
